import { translate } from '@lucidlink/uicore';
export const getSearchResultsLabel = ({ noResultsLabel, resultsCount, }) => {
    if (resultsCount === undefined) {
        return undefined;
    }
    return resultsCount === 0
        ? noResultsLabel
        : translate('{{count}} results', { count: resultsCount });
};
